export interface CallTimeOfDayCount {
    hour: number;
    weekDayIndex: number;
    value: number;
}
